import { Flag } from 'lucide-react';

interface FollowUpButtonProps {
    count: number;
    loading: boolean;
    onClick: () => void;
}

export function FollowUpButton({ count, loading, onClick }: FollowUpButtonProps) {
    return (
        <button
            onClick={onClick}
            className="rounded-lg border border-orange-200 bg-white px-4 py-3 text-left transition-colors hover:border-orange-300 hover:bg-orange-50/50"
        >
            <div className="flex items-center gap-1.5">
                <Flag className="h-3.5 w-3.5 text-orange-500" />
                <p className="text-xs font-medium text-gray-500">Follow-ups</p>
            </div>
            <p className="mt-1 text-xl font-semibold text-orange-600">
                {loading ? '...' : count}
            </p>
        </button>
    );
}
